import React, { useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { insidePages } from '../data/content';
import { OFFER_ANCHOR } from '../data/config';
import { CtaButton } from './CtaButton';
export function InsideLookSection() {
  const [index, setIndex] = useState(0);
  const dragged = useRef(false);
  const total = insidePages.length;
  const go = (dir: 1 | -1) => setIndex(i => (i + dir + total) % total);
  const page = insidePages[index];
  return <section className="bg-pale px-4 py-6 text-center md:px-12 md:py-8" data-id="element-108" data-mp="3el1moau043nv">
      <h2 className="font-heading text-[24px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-navy md:text-[32px]" data-id="element-109" data-mp="3sjj4xt150nye">
        Look inside
      </h2>
      <p className="mt-1.5 font-heading text-[14px] font-bold uppercase leading-tight text-brand md:text-[16px]" data-id="element-110" data-mp="17s90m4sz89ep">
        Explore the complete AQUA CLASS HUB™ bundle
      </p>
      <p className="mx-auto mt-1.5 max-w-[600px] text-[13px] leading-[1.45] text-ink md:text-[14px]" data-id="element-111" data-mp="12vs7ew6x74ur">
        Take a closer look at the complete class timelines, step-by-step exercise instructions, intensity options,
        exact workout timings, movement illustrations, and instructor cues included in the collection. Every class is
        organized to help you quickly find a session that matches your group and your teaching goals.
      </p>

      <div className="relative mx-auto mt-4 max-w-[440px]" role="region" aria-roledescription="carousel" aria-label="Page previews" data-id="element-112" data-mp="24l8mvr103ueb">
        <div className="overflow-hidden rounded-md border border-line bg-white shadow-soft" data-id="element-113" data-mp="29h7inzonseor">
          <AnimatePresence mode="wait" initial={false} data-id="element-114" data-mp="2eh2aq6k67abe">
            <motion.a key={index} href={OFFER_ANCHOR} drag="x" dragConstraints={{
            left: 0,
            right: 0
          }} dragElastic={0.2} onDragStart={() => dragged.current = true} onDragEnd={(_, info) => {
            if (info.offset.x < -50) go(1);else if (info.offset.x > 50) go(-1);
            setTimeout(() => dragged.current = false, 0);
          }} onClick={e => dragged.current && e.preventDefault()} initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.18,
            ease: 'easeOut'
          }} className="block aspect-[4/5] w-full cursor-grab touch-pan-y active:cursor-grabbing" aria-label={`Preview ${index + 1} of ${total} — go to the special offer`} data-id="element-115" data-mp="2j9d8p3vcom1b">
              <img src={page.image} alt={page.alt} className="h-full w-full object-cover" draggable={false} data-id="element-116" data-mp="19s7s0ltfprm8" />
            </motion.a>
          </AnimatePresence>
        </div>
        <button type="button" onClick={() => go(-1)} aria-label="Previous preview" className="absolute left-2 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-line bg-white text-navy shadow-soft transition-colors duration-150 hover:text-brand" data-id="element-117" data-mp="2l6246rp4sewo">
          <ChevronLeftIcon className="h-5 w-5" data-id="element-118" data-mp="70doym226tbi" />
        </button>
        <button type="button" onClick={() => go(1)} aria-label="Next preview" className="absolute right-2 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-line bg-white text-navy shadow-soft transition-colors duration-150 hover:text-brand" data-id="element-119" data-mp="3p577yua3pibi">
          <ChevronRightIcon className="h-5 w-5" data-id="element-120" data-mp="poscgzd63p7k" />
        </button>
      </div>

      <div className="mt-3 flex justify-center gap-1.5" role="tablist" aria-label="Choose preview" data-id="element-121" data-mp="bwuad8hvitkw">
        {insidePages.map((p, i) => <button key={p.image} type="button" role="tab" onClick={() => setIndex(i)} aria-label={`Show preview ${i + 1}`} aria-selected={i === index} className={`h-2 rounded-full transition-[width,background-color] duration-200 ease-out ${i === index ? 'w-5 bg-navy' : 'w-2 bg-line'}`} data-id="element-122" data-mp="guvyi7u5pj38" data-mpi={i} />)}
      </div>

      <p className="mt-4 font-heading text-[13px] font-extrabold uppercase leading-tight text-goldDark md:text-[15px]" data-id="element-123" data-mp="37vo4684c9abn">
        Every exercise has a purpose. Every class has a plan.
      </p>

      <p className="mt-4 font-heading text-[14px] font-extrabold uppercase leading-tight text-navy md:text-[16px]" data-id="element-124" data-mp="3hpzhrpkdumm">
        Imagine walking into your next class with the whole session already planned.
      </p>
      <div className="mt-2.5" data-id="element-125" data-mp="3quinlueqyyy5">
        <CtaButton mode="scroll" subtext="See the special launch offer" data-id="element-126" data-mp="3qth89dqp7qam">
          I want all 72 classes ready to teach!
        </CtaButton>
      </div>
    </section>;
}